__turbopack_context__.v({
  "app-container": "_0V6lUG_app-container",
  "button": "_0V6lUG_button",
  "cards-list-item": "_0V6lUG_cards-list-item",
  "cards-list-item-eyebrow": "_0V6lUG_cards-list-item-eyebrow",
  "cards-list-item-icons": "_0V6lUG_cards-list-item-icons",
  "cards-list-item-image": "_0V6lUG_cards-list-item-image",
  "cards-title-eyebrow": "_0V6lUG_cards-title-eyebrow",
});
